import React, { useEffect, useRef, useState } from 'react';
import { Box, LinearProgress, withStyles } from "@material-ui/core";
import { getEmbedSDK } from '@looker/embed-sdk';

import {acquireLookerCookielessSession, refreshLookerCookielessToken} from "../../stores/api";

const LOOKER_URL = "https://gojitsu.cloud.looker.com";
const StyledProgress = withStyles({
  indeterminate: {
    backgroundColor: "#bcdfca"
  },
  bar: {
    backgroundColor: "#4dc481"
  }
})(LinearProgress)

export default function CookielessLookerEmbed({dashboard}) {
  const [initializing, setInitializing] = useState(false);
  const dashboardRef = useRef(dashboard);

  useEffect(() => {
    dashboardRef.current = dashboard;
  }, [dashboard]);

  const acquireSession = async () => {
    return acquireLookerCookielessSession(dashboardRef.current?.id)
      .then(res => res.data);
  };

  const refreshTokens = async (tokens) => {
    return refreshLookerCookielessToken(tokens).then(res => res.data);
  };

  useEffect(() => {
    getEmbedSDK().init(LOOKER_URL);
    getEmbedSDK().initCookieless(LOOKER_URL, acquireSession, refreshTokens);
  }, []);

  useEffect(() => {
    if (!!dashboard) {
      setInitializing(true);
      document.getElementById("looker-frame").innerHTML = "";
      getEmbedSDK().createDashboardWithId(dashboard.external_id)
        .appendTo('#looker-frame')
        .build()
        .connect()
        .catch(console.error)
        .finally(() => {
          setInitializing(false);
        });
    }
  }, [dashboard]);

  return (
    <Box style={{height: "100%"}}>
      {initializing && <StyledProgress />}
      <div id="looker-frame"/>
    </Box>
  );
}
